import { Discount } from '../../../types/discounts';

export enum ActionTypes {
    GetDiscounts = '[customer/discounts] GET_DISCOUNTS',
    FetchDiscountsResponse = '[customer/discounts] FETCH_DISCOUNTS_RESPONSE',
    FetchNextResponse = '[customer/discounts] FETCH_NEXT_RESPONSE',
    SetActiveDiscount = '[customer/discount] SET_ACTIVE_DISCOUNT',
    ClearActiveDiscount = '[customer/discount] CLEAR_ACTIVE_DISCOUNT'
}

export enum GetDiscountsReason {
    mount = 'mount',
    update = 'update',
    next = 'next',
    refresh = 'refresh',
}

export interface GetDiscounts {
    type: ActionTypes.GetDiscounts
    ;
    payload: {
        accountId: string;
        id: string;
        params: URLSearchParams;
        requestId: number;
        reason: GetDiscountsReason;
    };
}
export interface FetchDiscountsResponse {
    type: ActionTypes.FetchDiscountsResponse;
    payload: {
        discounts: Discount[];
    };
    meta: {
        cause: GetDiscounts;
    };
}

export interface FetchNextResponse {
    type: ActionTypes.FetchNextResponse;
    payload: {
        discounts: Discount[];
    };
    meta: {
        cause: FetchDiscountsResponse;
    };
}

export interface SetActiveDiscount {
    type: ActionTypes.SetActiveDiscount;
    payload: {
        discountId: string;
    };
}

export interface ClearActiveDiscount {
    type: ActionTypes.ClearActiveDiscount;
    payload: {};
}

export function getDiscounts(
    accountId: string,
    id: string,
    params: URLSearchParams,
    reason: GetDiscountsReason
): GetDiscounts {
    return {
        type: ActionTypes.GetDiscounts,
        payload: {
            accountId,
            id,
            params,
            reason,
            requestId: performance.now(),
        },
    };
}

export function setActiveDiscount(
    discountId: string
): SetActiveDiscount {
    return {
        type: ActionTypes.SetActiveDiscount,
        payload: {
            discountId,
        },
    };
}

export function clearActiveDiscount(): ClearActiveDiscount {
    return {
        type: ActionTypes.ClearActiveDiscount,
        payload: {},
    };
}

export type Actions =
    | GetDiscounts
    | FetchDiscountsResponse
    | FetchNextResponse
    | SetActiveDiscount
    | ClearActiveDiscount;
